import { completeTypes, createTypes, withPostSuccess } from 'redux-recompose';

import { CONTRACTS_EVENTS, CONTRACTS_NAMES, CONTRACTS_FUNCTIONS } from '#models/contracts/constants';
import * as ContractsService from '#services/ContractsService';
import { MODALS } from '#redux/Modal/constants';
import MashingsActions from '#redux/Mashings/actions';

import { SPIRIT_TARGETS } from './constants';
import { mapAddSpirit, mapUpdateSpiritStep } from './mappers';

export const actions = createTypes(
  completeTypes({
    primaryActions: ['GET_ALL_ADDED_SPIRITS', 'ADD_SPIRIT'],
    ignoredActions: ['SET_CURRENT_SPIRIT']
  }),
  '@@SPIRITS'
);

export const actionCreators = {
  getAllAddedSpirits: () => ({
    type: actions.GET_ALL_ADDED_SPIRITS,
    target: SPIRIT_TARGETS.ADDED_SPIRITS,
    payload: { event: CONTRACTS_EVENTS.SPIRIT_ADDED, contractName: CONTRACTS_NAMES.SPIRIT },
    service: ContractsService.getAllEvents
  }),
  addSpirit: (values, id) => ({
    type: actions.ADD_SPIRIT,
    target: SPIRIT_TARGETS.ADD_SPIRIT,
    payload: {
      functionName: CONTRACTS_FUNCTIONS.ADD_SPIRIT,
      contractName: CONTRACTS_NAMES.SPIRIT,
      functionParams: mapAddSpirit(values)
    },
    service: ContractsService.execFunction,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(
          MashingsActions.updateMashById({
            id,
            values: mapUpdateSpiritStep(values),
            postSuccessAction: MashingsActions.getAllMashesAndCloseModal(MODALS.SPIRIT_STEP)
          })
        );
      })
    ]
  }),
  setCurrentSpirit: payload => ({
    type: actions.SET_CURRENT_SPIRIT,
    target: SPIRIT_TARGETS.CURRENT_SPIRIT,
    payload
  })
};

export default actionCreators;
